import { defineStore } from "pinia";
import useComments from "@/composables/useComments";
import { IConversation } from "@/schemas/comments/commentsSchema";

interface State {
  enableComments: boolean;
  commentsOpen: boolean;
  allComments: IConversation[];
  loading: boolean;
  unread: boolean;
  openDetail: boolean;
  isNotAtHome: boolean;
  sortBy: "date" | "unread";
  showResolved: boolean;
  detailKey?: string;
  hoveredConversationInfo?: {
    type?: "section" | "block";
    sectionIndex?: number;
    columnIndex?: number;
    blockIndex?: number;
  };
  intervalToComments?: any;
  commentsInterval?: number;
}

export const useCommentsStore = defineStore("commits", {
  state: (): State => ({
    enableComments: false,
    commentsOpen: false,
    allComments: [],
    loading: false,
    unread: false,
    isNotAtHome: false,
    openDetail: false,
    sortBy: "date",
    showResolved: false,
  }),

  getters: {
    hoverOverElement:
      (state) =>
      (prop: any): any => {
        if (
          state.hoveredConversationInfo &&
          state.hoveredConversationInfo.type === prop.type
        ) {
          if (
            prop.type === "section" &&
            state.hoveredConversationInfo.sectionIndex === prop.sectionIndex
          ) {
            return true;
          }
          if (
            prop.type === "block" &&
            state.hoveredConversationInfo.sectionIndex === prop.sectionIndex &&
            state.hoveredConversationInfo.columnIndex === prop.columnIndex &&
            state.hoveredConversationInfo.blockIndex === prop.blockIndex
          ) {
            return true;
          }
        }

        return false;
      },
  },

  actions: {
    clearIntervalToComments() {
      if (this.intervalToComments) clearInterval(this.intervalToComments);
    },

    setEnableComments(val: boolean) {
      this.enableComments = val;
    },

    startLoadingCommnets() {
      if (this.enableComments) {
        const { loadAllComments } = useComments();
        loadAllComments();

        if (this.commentsInterval) {
          this.intervalToComments = setInterval(() => {
            loadAllComments();
          }, this.commentsInterval);
        }
      }
    },

    toggleOpenComments() {
      this.commentsOpen = !this.commentsOpen;
      if (!this.commentsOpen) {
        this.openDetail = false;
      }
    },
  },
});
